import { useContext } from 'react'
import { InitialDataContext } from 'src/contexts/InitialDataProvider'

export default function useInitialData() {
  return useContext(InitialDataContext)
}
